(() => {
  'use strict';
  if (window.aoAdversarialUxFixesBooted) return;
  window.aoAdversarialUxFixesBooted = true;

  const restoreMobilePdp = () => {
    document.querySelectorAll('[data-ao-mobile-purchase-anchor]').forEach(anchor => {
      const key = anchor.getAttribute('data-ao-mobile-purchase-anchor');
      const node = document.querySelector(`[data-ao-mobile-purchase-node="${key}"]`);
      if (node && anchor.parentNode) {
        anchor.parentNode.insertBefore(node, anchor.nextSibling);
        node.removeAttribute('data-ao-mobile-purchase-node');
      }
      anchor.remove();
    });
    document.querySelectorAll('[data-ao-mobile-purchase-priority]').forEach(node => node.remove());
    document.querySelectorAll('[data-ao-mobile-purchase-node]').forEach(node => node.removeAttribute('data-ao-mobile-purchase-node'));
  };

  const suppressDrawerUpsells = () => {
    document.querySelectorAll('header-cart-drawer *').forEach(node => {
      if (node.children.length || node.textContent.trim().toLowerCase() !== 'goes great with') return;
      let candidate = node.parentElement;
      while (candidate && !candidate.matches('.cart__drawer-form')) {
        const buttons = candidate.querySelectorAll('button, a').length;
        if (buttons >= 2) {
          candidate.hidden = true;
          candidate.setAttribute('data-ao-cart-upsell-hidden', '');
          break;
        }
        candidate = candidate.parentElement;
      }
    });
    document.querySelectorAll('header-cart-drawer .cart-recommendations').forEach(node => {
      node.hidden = true;
      node.setAttribute('data-ao-cart-upsell-hidden', '');
    });
  };

  const isSoldOutCard = card => {
    if (!card || card.nodeType !== 1) return false;
    if (card.querySelector('.ao-cro-button--unavailable, button[name="add"][disabled], [aria-disabled="true"]')) return true;
    const stock = card.querySelector('.ao-cro-card__stock, [class*="inventory"], [class*="stock"], button, .btn');
    return !!(stock && /\bsold out\b/i.test(stock.textContent || ''));
  };

  const pushSoldOutToEnd = () => {
    document.querySelectorAll('.collection-grid').forEach(grid => {
      const cards = Array.from(grid.children);
      if (cards.length < 2) return;
      const available = cards.filter(card => !isSoldOutCard(card));
      const soldOut = cards.filter(isSoldOutCard);
      if (!available.length || !soldOut.length) return;
      const desired = available.concat(soldOut);
      if (desired.every((node, index) => node === cards[index])) return;
      const fragment = document.createDocumentFragment();
      desired.forEach(node => fragment.appendChild(node));
      grid.appendChild(fragment);
    });
  };

  const suppressExpiredPromoLinks = () => {
    document.querySelectorAll('header a, header-drawer a, nav a').forEach(link => {
      const text = (link.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
      const href = (link.getAttribute('href') || '').toLowerCase();
      if (text !== 'labor day sale' && !href.includes('laborday26')) return;
      const item = link.closest('li, .site-nav__item, .mobile-nav__item, .header-item') || link;
      if (!item.hidden) {
        item.hidden = true;
        item.setAttribute('data-ao-expired-promo-hidden', '');
      }
    });
  };

  let queued = false;
  const apply = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      queued = false;
      restoreMobilePdp();
      suppressDrawerUpsells();
      pushSoldOutToEnd();
      suppressExpiredPromoLinks();
    }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('ajaxProduct:added', () => setTimeout(apply, 50));
  window.addEventListener('resize', apply, { passive: true });

  window.addEventListener('pageshow', apply, { passive: true });
  document.addEventListener('cart:build', () => setTimeout(apply, 0));

  const startObserver = () => {
    if (!document.body || document.body.classList.contains('template-product')) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const observer = new MutationObserver(apply);
    observer.observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  else startObserver();
})();

/* AO STAY-PUT CART HANDLER — Sep 21 2026 */
(() => {
  'use strict';
  if (window.aoStayPutCartBooted) return;
  window.aoStayPutCartBooted = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const validCartMarkup = (markup) => {
    if (typeof markup !== 'string' || !markup.trim()) return false;
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    return !!(
      doc.querySelector('.cart__items[data-count]') &&
      doc.querySelector('.cart__subtotal') &&
      doc.querySelector('.cart__header')
    );
  };

  const getCartMarkup = async () => {
    const response = await fetch(root() + '?section_id=cart-ajax', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart drawer section unavailable');
    const markup = await response.text();
    if (!validCartMarkup(markup)) throw new Error('Invalid cart drawer section');
    return markup;
  };

  const openNativeCartDrawer = async (source, productResponse = {}) => {
    let markup = productResponse?.sections?.['cart-ajax'];
    if (!validCartMarkup(markup)) markup = await getCartMarkup();

    const product = Object.assign({}, productResponse, {
      sections: Object.assign({}, productResponse?.sections, { 'cart-ajax': markup })
    });

    const target = source && source.isConnected ? source : document;
    target.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      bubbles: true,
      detail: { product, addToCartBtn: source }
    }));
  };

  /* Newer AO product-form intentionally emits this event before redirecting to /cart.
     Cancel that navigation and use Expanse's native cart drawer instead. */
  document.addEventListener('product-form:cart:navigate', (event) => {
    event.preventDefault();
    const productForm = event.target;
    const button = productForm?.querySelector('button[type="submit"], input[type="submit"]');
    openNativeCartDrawer(button || productForm, event.detail?.response || {}).catch((error) => {
      console.error('AO cart drawer refresh failed:', error);
      document.dispatchEvent(new CustomEvent('cart:build'));
      (button || productForm || document).dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    });
  });

  /* Catch custom AO cards that submit directly to /cart/add and have no JS controller.
     Native Expanse forms and legacy aof-add-form forms are excluded to prevent double adds. */
  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : event.target?.closest?.('form');
    if (!form) return;

    const action = form.getAttribute('action') || '';
    if (!/\/cart\/add(?:\.js)?(?:[?#].*)?$/i.test(action)) return;

    if (
      form.closest('product-form') ||
      form.closest('block-buy-buttons') ||
      form.closest('quick-add') ||
      form.closest('at-add-to-cart')
    ) return;

    /* Product-card forms (including aof-add-form) are owned here globally.
       Stop legacy campaign listeners from submitting or posting a second time. */
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.aoStayPutBusy === 'true') return;

    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalText = button?.tagName === 'INPUT' ? button.value : button?.textContent;
    form.dataset.aoStayPutBusy = 'true';

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (button.tagName === 'INPUT') button.value = 'Adding...';
      else button.textContent = 'Adding...';
    }

    try {
      const formData = new FormData(form);
      formData.set('sections', 'cart-ajax');
      formData.set('sections_url', window.location.pathname);

      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const result = await response.json();
      if (!response.ok || Number(result.status) >= 400) {
        throw new Error(result.description || result.message || 'This item could not be added.');
      }

      await openNativeCartDrawer(button || form, result);
    } catch (error) {
      console.error('AO add-to-cart failed:', error);
      let notice = form.querySelector('[data-ao-stay-put-error]');
      if (!notice) {
        notice = document.createElement('div');
        notice.dataset.aoStayPutError = '';
        notice.setAttribute('role', 'alert');
        form.appendChild(notice);
      }
      notice.textContent = error?.message || 'This item could not be added.';
    } finally {
      delete form.dataset.aoStayPutBusy;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (button.tagName === 'INPUT') button.value = originalText || 'Add to cart';
        else button.textContent = originalText || 'Add to cart';
      }
    }
  }, true);
})();
